import React, { useState, useContext, useEffect } from 'react';

import { DataContext } from '../stores/crm-deal-store';
import VirtualScrollerDeal from '../components/crm/deal/VirtualScrollerDeal';
import { GetPipelineStages } from '../components//crm/requests/PipelineRequests';
import ErrorPage from './error';
import Pipeline from '../components/crm/deal/PipelineModel';
import { DeepCopy } from '../components/tables/shared/TableEventHelpers';

const CrmDeals = (dealParams) => {
    const [error] = useState(null);
    const [isDoingInitialFetch, setIsDoingInitialFetch] = useState(false);

    const {
        store: {
            apiUrl,
            defaultFilters,
            pipelines,
            currentPipelineId,

            userFilterType,
            selectedUsersOptions,
            selectedUserGroupOption,
            selectedBossGroupOption,

            initialViewSettings,
            initialRequestObject,
        },
        dispatch,
    } = useContext(DataContext);

    const pipelineId = dealParams.pipelineId;

    const finishedSettingsFetch = (res) => {
        if (res.success) {
            // Create c# dictionary from defaultFilters in store
            const filterDictionary = {};
            Object.keys(defaultFilters).forEach((filterKey) => {
                // Try getting cached value, otherwise use default
                filterDictionary[filterKey] =
                    JSON.parse(localStorage.getItem(`deal-filter-${filterKey}`))?.id || defaultFilters[filterKey].id;
            });

            let requestObject = DeepCopy(initialRequestObject);
            //requestObject.filters = filterDictionary;
            switch (userFilterType.id) {
                case 'user':
                    requestObject.filters['GroupType'] = 'Users';
                    requestObject.filters['Users'] = JSON.stringify(selectedUsersOptions ?? []);
                    break;
                case 'boss':
                    requestObject.filters['GroupType'] = 'Boss';
                    requestObject.filters['Users'] =
                        JSON.stringify([{
                            id: selectedBossGroupOption.coaEmpId,
                            name: selectedBossGroupOption.name,
                            //coaEmpId: selectedBossGroupOption.coaEmpId,
                        }]);
                    break;
                case 'group':
                    requestObject.filters['GroupType'] = 'Group';
                    requestObject.filters['Users'] =
                        JSON.stringify([{
                            id: selectedUserGroupOption.id,
                            name: selectedUserGroupOption.name,
                            //coaEmpId: selectedUserGroupOption.coaEmpId,
                        }]);
                    break;
            }

            let stageIds = [];
            res.data.forEach((stage) => {
                stageIds.push(stage.id);
            });

            requestObject.pipelineStageIds = stageIds;

            const pipe = new Pipeline(pipelineId, DeepCopy(initialViewSettings), requestObject, res.data, {}, true);

            pipelines[pipelineId] = pipe;

            dispatch({
                type: 'UPDATE_CURRENT_PIPE_ID',
                pipelineId: pipelineId,
            });

            dispatch({
                type: 'UPDATE_FETCH_PIPES',
                pipelines: pipelines,
            });
        }
        setIsDoingInitialFetch(false);
    };

    useEffect(() => {
        setIsDoingInitialFetch(true);
        if (pipelines[pipelineId]) {
            dispatch({
                type: 'UPDATE_CURRENT_PIPE_ID',
                pipelineId: pipelineId,
            });
            return;
        }

        GetPipelineStages(finishedSettingsFetch, pipelineId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pipelineId]);

    return error && error ? (
        <ErrorPage error={error} />
    ) : (
        <section className='w-100 crm-container'>
            {pipelines[pipelineId] !== undefined && pipelines[pipelineId].pipelineStages !== undefined ? (
                <div className='crm-container-details'>
                    <VirtualScrollerDeal dataContext={DataContext} pipelineId={pipelineId} isDoingInitialFetch={isDoingInitialFetch} />
                </div>
            ) : null}
        </section>
    );
};

export default CrmDeals;
